import { useMemo } from "react";
import { useRecentlyViewed } from "@/lib/useRecentlyViewed";
import { products } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";

interface Props {
  excludeId?: string;
}

export function RecentlyViewed({ excludeId }: Props) {
  const { getIds } = useRecentlyViewed();

  const recentProducts = useMemo(() => {
    const ids = getIds().filter((id) => id !== excludeId);
    return ids
      .map((id) => products.find((p) => p.id === id))
      .filter(Boolean)
      .slice(0, 4) as typeof products;
  }, [excludeId]);

  if (recentProducts.length === 0) return null;

  return (
    <section className="mt-20 pt-12 border-t border-stone-100">
      <div className="text-center mb-10">
        <p className="text-[10px] tracking-[0.3em] uppercase text-stone-400 font-semibold mb-2">
          La tua navigazione
        </p>
        <h2 className="font-semibold text-lg sm:text-xl md:text-2xl md:font-bold text-stone-900 tracking-tight">
          Visti di recente
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {recentProducts.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </section>
  );
}
